export class ErrorData {
  constructor(public title: string, public message: string) {}
}
